export enum TranslationState {
    NotTranslated = 1,
    Translated,
    Draft,
    PreTranslated,
    AutoTranslated,
}